import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const openLoader = createAction('openLoader');
export const closeLoader = createAction('closeLoader');
